// Central route map -- every in-app page path is now a random opaque
// segment instead of a readable word (e.g. "/dashboard" -> "/aadzooc").
//
// This trades away readable URLs / bookmarks / "I was on /rate-card
// when..." bug reports for the route NAME not being human-guessable.
// It adds NO access control by itself -- who can actually load a page
// (RoleProtectedRoute in App.jsx) and who the API will return data to
// (@jwt_required / require_tier in app.py) are completely unchanged.
//
// Every <Route path=...> in App.jsx and every navigate(...)/<Link
// to=...> anywhere else in the app should reference these constants
// instead of a literal string, so there is exactly one place to look
// up or ever change a path. If a path here ever needs to change,
// update it ONLY in this file.
export const ROUTES = {
  DASHBOARD: "/aadzooc",
  MASTER: "/um8d5fd",
  PROJECT: "/a7ierc6",
  RATE_CARD: "/yeegfmq",
  COST_ESTIMATION_STEP1: "/egdhhy2",
  COST_ESTIMATION_STEP2: "/egmj49h",
  COST_ESTIMATION_STEP3: "/twzi6gu",
  COST_ESTIMATION_STEP4: "/zwa7yxq",
  COST_ESTIMATION_STEP5: "/wm1rttp",
  COST_ESTIMATION_SUMMARY: "/uwu68ix",
  BASIS_OF_COST: "/fjeonhr",
  ELEMENT_SCOPE_PAGE1: "/sbki5xo",

  // Read-only "view" counterparts of the 7 wizard steps above -- separate
  // components/routes, never the editable Step1.../BasisOfCost/
  // ElementScopePage1 pages themselves. EstimationSummary.jsx's step
  // indicator links here instead of the editable routes, so browsing a
  // completed project's steps from Summary can never touch the real
  // create/edit wizard flow.
  COST_ESTIMATION_STEP1_VIEW: "/vq2mfxr",
  COST_ESTIMATION_STEP2_VIEW: "/pl9tkzc",
  COST_ESTIMATION_STEP3_VIEW: "/rw4hbde",
  COST_ESTIMATION_STEP4_VIEW: "/nx7cqty",
  COST_ESTIMATION_STEP5_VIEW: "/kf3jvsm",
  BASIS_OF_COST_VIEW: "/yt8bnwq",
  ELEMENT_SCOPE_PAGE1_VIEW: "/cz5rdgh",
  ACCOUNT_USERS: "/g9lqd4e",
  ACCOUNT_USERS_CREATE: "/sjn32v9",
  ACCOUNT_USERS_EDIT: "/gci4e9z", // + "/:id" in App.jsx's <Route>, + "/<token>" everywhere else
  // Access Request tab's View/Edit page (EditAccessRequestForm.jsx) --
  // + "/:id" in App.jsx's <Route>, same as ACCOUNT_USERS_EDIT above.
  ACCESS_REQUEST_EDIT: "/qz4rwbp",
  ACCOUNT_ROLES: "/nrhtt6x",
  ACCOUNT_DEPARTMENTS: "/b6c26ih",
  ACCOUNT_COMPANIES: "/mmeyqq6",
  ACCOUNT_MANAGE_ROLES: "/m2i2a6b",
  ACCOUNT_ROLE_MATRIX: "/dk58jqx",
  PROFILE: "/jds7uhy",
  CHANGE_PASSWORD: "/d980isq",
  HELP: "/g33cp72",
  NOTIFICATIONS: "/tbfcdgb",
  CONFIG_MAIL: "/hsv5peo",
  CONFIG_MAIL_TEMPLATE_NEW: "/sj8kgr9",
  AI_ASSISTANT: "/nxiw0c4",
};

// Helper for the one route that also carries a (separately encrypted)
// user-id path segment -- see url-id-encryption-process.md Phase 1.
export function editUserPath(id) {
  return `${ROUTES.ACCOUNT_USERS_EDIT}/${id}`;
}

// Same idea for the Access Request edit/view page -- AccessRequestID is a
// plain (unencrypted) integer, so this is just a straight concatenation,
// unlike editUserPath() above.
export function editAccessRequestPath(id) {
  return `${ROUTES.ACCESS_REQUEST_EDIT}/${id}`;
}
